export default "__VITE_ASSET__BQDSGrvD__"